import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Grid from '@material-ui/core/Grid';
import { Box, Paper, Typography } from '@material-ui/core';
import type { IFilter, IWorkViewPrimaryGroup, IWorkViewPrimaryGroupData } from '../WorkViewInterfaces';
import WorkViewSet from '../SetView';

const useStyles = makeStyles(() => createStyles({
  primaryGroup: {
    width: '202px',
    maxWidth: '202px',
    display: 'block',
    flexShrink: 0,
    float: 'left',
  },
  primaryGroupName: {
    font: 'Roboto',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '18.75px',
    color: '#2F2F2F',
    padding: '2px 0',
  },
  countStyle: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '14.06px',
  },
  scrollable: {
    display: 'flex',
    overflowY: 'hidden',
    paddingBottom: '27px',
  },
  listItem: {
    padding: '2px 0',
  },
}));

interface VerticalLayoutProps {
  primaryGroups: IWorkViewPrimaryGroup[];
  primaryGroupData: IWorkViewPrimaryGroupData[];
  filter: IFilter;
}

const VerticalLayout: React.FC<VerticalLayoutProps> = ({ primaryGroups, primaryGroupData, filter }) => {
  const classes = useStyles();

  const calculateScrollWidth = () => 202 * primaryGroups.length;

  // Sets the height of each column so that the borders are pulled down for primaryGroups with less workviewsets compared to other primaryGroups
  const findHeightOfEachColumn = () : number => {
    let maxSetNumberInAnyPrimaryGroup = 0;
    let columnHeight = 111;
    primaryGroups.forEach((pg) => {
      maxSetNumberInAnyPrimaryGroup = pg.sets.length > maxSetNumberInAnyPrimaryGroup ? pg.sets.length : maxSetNumberInAnyPrimaryGroup;
    });
    columnHeight += maxSetNumberInAnyPrimaryGroup > 1 ? 55 * (maxSetNumberInAnyPrimaryGroup - 1) : 0;
    return columnHeight;
  };

  return (
    <Paper>
      <div className={classes.scrollable}>
        <Grid xs={12}>
          <Grid
            container
            spacing={7}
            style={{
              margin: 0, display: 'block', width: `${calculateScrollWidth()}px`,
            }}
          >
            {primaryGroups.map((primaryGroup, index) => (
              <Grid
                key={primaryGroup.primaryGroupId}
                item
                xs={2}
                className={classes.primaryGroup}
                style={{
                  padding: '40px 0 20px 0',
                  borderRight: index !== primaryGroups.length - 1 ? '1px solid #F2F2F2' : 'none',
                }}
              >
                <Box style={{ padding: '0 44px', height: `${findHeightOfEachColumn()}px` }}>
                  <List style={{ padding: 0 }}>
                    <ListItem className={classes.listItem}>
                      <Typography className={classes.primaryGroupName}>
                        {primaryGroup.name}
                      </Typography>
                    </ListItem>
                    <ListItem className={classes.listItem}>
                      <Typography className={classes.countStyle}>
                        {`${primaryGroupData[index].totalItems.toString()} Total Items`}
                      </Typography>
                    </ListItem>
                    <br />
                    <div style={{ flex: '1 1 auto', overflowY: 'auto' }}>
                      {primaryGroup.sets.map((set, setIndex) => (
                        <WorkViewSet
                          key={set.workViewSetId}
                          setName={set.name}
                          isColored={set.color}
                          color={filter.color}
                          displayStyle={set.displayStyle}
                          setData={primaryGroupData[index].sets[setIndex].totalItems}
                        />
                      ))}
                    </div>
                  </List>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </div>
    </Paper>
  );
};

export default VerticalLayout;
